// components/Portal.js
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

export function Portal({ children }) {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
        return () => setMounted(false);
    }, []);

    if (!mounted) return null;

    return ReactDOM.createPortal(children, document.body);
}
